
const websocket    = require('../../../../../js-network/web-socket')
const usersDialog  = require ('./users-dialog')
const dbRequest    = require ('../../../../../js-network/db-request')





export function receiver (detail) { //console.log('command receiver>', detail)

    switch (detail.data.command){
        case 'restart':           usersDialog.start({ "elem":"dialog", "id":"restart", "act":"show"});   break;
        case 'logOthersOut':      location.reload();                                                      break;
        case 'unlockOrLockUsers': location.reload();  
    }
} 



export function executeCommand(detail) {
    
    switch (detail.command) {
        case 'restart': sender(detail);
            break;

        case 'logOthersOut': logOthersOut(detail);
            sender(detail);
            break;

        case 'unlockOrLockUsers': unlockOrLockUsers(detail);
            sender(detail);
            break;
    }
}


//all user element, only handle commands
//commands are actions sent to only one person
function sender (detail) { 

      websocket.send({
            act: 'command', 
            data: { 
                command: detail.command,
                company: detail.company,
                id:      detail.id,
                result:  detail.result
            }  
      })
}/**/



const logOthersOut = (detail) => {  
   
    detail.inf = { 
          reason:'',
          usersIds:JSON.stringify([detail.id]),

    }

    //console.log('logOthersOut>',  detail.inf )

    //alert('to logout')
    return DB(detail, 'server/php/auth/logOthersOut.php')
      .then((result)=>  {   

        //console.log('logOthersOut result>', result)

      }).catch((error) => {  
            //console.log('logOthersOut error', error)
      }) 
      
}/**/

const unlockOrLockUsers = (detail) => {  //console.log('unlockOrLockUsers>')
   
    detail.inf = { 
        status  : detail.status,
        reason  : '',
        usersIds: JSON.stringify([detail.id]),
    }

    //console.log('unlockOrLockUsers>',  detail.inf )

    return DB(detail, 'server/php/auth/unlockOrLockUsers.php')
      .then((result)=>  {   

       // console.log('logOthersOut result>', result)


      }).catch((error) => {  
            // console.log('logOthersOut error', error)
     }) 
      
}/**/


async function DB(detail, phpFile){  //console.log('downloadSettings>')

   const result = await dbRequest.start(detail, phpFile) //do the insert

   if(result.status != "ok"){ throw ( result ) }

   return result
}
